import Error from "../../../components/Error";
import Success from "../../../components/Success";
import { useRegister } from "./modules/useRegister";

function RegisterTemplate() {
  const { isValidEmail, user, setUser, loading, error, success, register } =
    useRegister();

  const { name, email, password, cpassword } = user;
  return (
    <div>
      {loading && <h2>Loading...</h2>}
      {error.message && <Error message={error.message} />}

      <div className="row justify-content-center mt-5 mb-5">
        <div className="col-md-5">
          {success && <Success message="Register successfully" />}
          <div className="bs">
            <h1>Register Screen</h1>
            <input
              type="text"
              className="form-control"
              placeholder="name"
              name="name"
              value={name}
              onChange={(e) => {
                setUser((prev) => ({ ...prev, name: e.target.value }));
              }}
            />
            <input
              type="email"
              className={`form-control ${isValidEmail ? "" : "is-invalid"}`}
              placeholder="email"
              name="email"
              value={email}
              onChange={(e) => {
                setUser((prev) => ({ ...prev, email: e.target.value }));
              }}
            />
            <input
              type="text"
              className="form-control"
              placeholder="password"
              name="password"
              value={password}
              onChange={(e) => {
                setUser((prev) => ({ ...prev, password: e.target.value }));
              }}
            />
            <input
              type="text"
              className="form-control"
              placeholder="confirm password"
              name="cpassword"
              value={cpassword}
              onChange={(e) => {
                setUser((prev) => ({ ...prev, cpassword: e.target.value }));
              }}
            />
            <button
              className={`btn ${
                error.message ? "btn-secondary" : "btn-primary"
              } mt-3`}
              onClick={register}
              disabled={error.message}
            >
              {loading ? "Processing..." : "Register"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RegisterTemplate;
